import APP_ACTIONS from '../constants/app-actions';
import localStorageAPI from '../services/local-storage-api';

const anonymousUser = {
    setAnonymousUserAgeValid: (data) => (dispatch, getState) => {
        sessionStorage.setItem('katapulk_age_valid', data.age_valid);
        dispatch({ type: APP_ACTIONS.ANONYMOUS_USER_AGE_VALID, payload: data });
    },
};

export default anonymousUser;



/** WEBPACK FOOTER **
 ** ./src/actions/anonymous-user.js
 **/